var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-report"},[_c('div',{staticClass:"report-text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('button',{staticClass:"report-button",on:{"click":function($event){return _vm.$emit('buttonClicked')}}},[_c('i',{staticClass:"yk-report"}),_c('span',[_vm._v("举报")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }